module.exports = __webpack_public_path__ + "img/dark.6fdea409.png";